<template>
  <div>
    <div class="container-fluid m-0 p-0">
       <div class="row justify-content-center">
        <div class="col-md-2 t-center mt-5 pt-5">
          <img src="@/assets/N+.png" alt="CompTIA A+ Logo" class="img-fluid mb-3"
          />
        </div>
      </div>

      <div class="row bg-white pt-5 pb-5 ms-5 border-bottom">
        <div class="col-md-1 p-0 t-center">Kapitel</div>
        <div class="col-md-2 p-0 t-center">PDF</div>

        <div class="col-md-3 p-0 t-center">Bezeichnung</div>
        <div class="col-md-2 p-0 t-center">Quiz</div>
        <div class="col-md-3 p-0 t-center">Link</div>
      </div>

      <div class="row ms-5" v-for="i in 22" :key="i">
        <div class="col-md-1 p-0 t-center">{{ i }}</div>
        <div class="col-md-2 p-0 t-center">
          <a :href="`/PDF/${$data['PDF' + i]}`" download v-if="$data['PDF' + i]">
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>

          <a
            :href="`/PDF/${$data['PDF' + i + 'a']}`"
            download
            v-if="$data['PDF' + i + 'a']"
          >
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-3 p-0 t-center">
          {{ $data["Titel" + i] }}
        </div>

        <div class="col-md-2 p-0 t-center">
          <a :href="$data['Link' + i]" target="_blank" v-if="$data['Link' + i]">
            <button class="btn btn-primary p-1 m-1" style="min-width: 160px">
              Zum Quiz {{ i }}
            </button>
          </a>
        </div>

        <div class="col-md-4 p-0 t-center">
          {{ $data["Link" + i] }}
        </div>
      </div>
      <h2 class="ps-5 pt-5">Ergänzungen</h2>
      <div class="row ms-5" v-for="i in 30" :key="i">
        <div class="col-md-1 p-0 t-center"></div>
        <div class="col-md-1 p-0 t-center">
          <a
            :href="`/PDF/${$data['PDF_sonstige' + i]}`"
            download
            v-if="$data['PDF_sonstige' + i]"
          >
            <button class="btn btn-secondary p-1 m-1" style="min-width: 100px">
              PDF Sonstige {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-3 p-0 t-center">
          {{ $data["PDF_sonstige" + i] }}
        </div>
      </div>
      <h2 class="ps-5 pt-5">90 Fragen Quiz</h2>
      <div class="row ms-5" v-for="i in 10" :key="i">
        <div class="col-md-1 p-0 t-center"></div>
        <div class="col-md-2 p-0 t-center">
          <a :href="$data['quiz90_' + i]" target="_blank" v-if="$data['quiz90_' + i]">
            <button class="btn btn-primary p-1 m-1" style="min-width: 160px">
              Zum Quiz {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-9 p-0 t-center">
          {{ $data["quiz90_" + i] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KapitelfragenQuizPage_N_Plus",

  data() {
    return {
      newSite: null,
      Titel1: "",
      Titel2: "Entwicklung und Modelle",
      Titel3: "Grundbegriffe der Telematik",
      Titel4: "Hardware im lokalen Netzwerk",
      Titel5: "Topologie und Verbindungsaufbau",
      Titel6: "Die Standards der IEEE-802.x-Reihe",
      Titel7: "Netzwerk ohne Kabel: Drahtlostechnologien",
      Titel8: "WAN-Datentechniken auf OSI-Layer 1 bis 3",
      Titel9: "Mein Name ist IP - Internet Protocol",
      Titel10: "Weitere Protokolle im TCP/IP-Stack",
      Titel11: "Stets zu Diensten",
      Titel12: "Netzwerke betreiben",
      Titel13: "Sicherheitsverfahren im Netzwerkverkehr",
      Titel14: "Verschiedene Angriffsformen im Netzwerk",
      Titel15: "Die Verteidigung des Netzwerks",
      Titel16: "Remote Access Networks",
      Titel17: "Netzwerkmanagement",
      Titel18: "Überwachung",
      Titel19: "Fehlersuche im Netzwerk",
      Titel20: "Praxis 1: Sie richten ein Netzwerk ein",
      Titel21: "Praxis 2: Sie richten ein WLAN ein",
      Titel22: "Praxis 3: Steigern Sie die Netzeffizienz",
      Link1: "",
      Link2: "https://forms.cloud.microsoft/e/T6Xt13U2dp?origin=lprLink",
      Link3: "https://forms.cloud.microsoft/e/vLzxrV7gES?origin=lprLink",
      Link4: "https://forms.cloud.microsoft/e/0U2NiicHQ9?origin=lprLink",
      Link5: "https://forms.cloud.microsoft/e/FiLTj6e6fg?origin=lprLink",
      Link6: "https://forms.cloud.microsoft/e/cKDVuPS7kt?origin=lprLink",
      Link7: "https://forms.cloud.microsoft/e/Ak4epMEj8W?origin=lprLink",
      Link8: "https://forms.cloud.microsoft/e/q88qHcaiSq?origin=lprLink",
      Link9: "https://forms.cloud.microsoft/e/vmHT5G56LJ?origin=lprLink",
      Link10: "https://forms.cloud.microsoft/e/nhi19rDyQN?origin=lprLink",
      Link11: "https://forms.cloud.microsoft/e/RwWsYKHkjf?origin=lprLink",
      Link12: "https://forms.cloud.microsoft/e/BBErP3p6Sx?origin=lprLink",
      Link13: "https://forms.cloud.microsoft/e/qFj5us5U5A?origin=lprLink",
      Link14: "https://forms.cloud.microsoft/e/t1Mp6mpzp6?origin=lprLink",
      Link15: "https://forms.cloud.microsoft/e/zQAfjijz21?origin=lprLink",
      Link16: "https://forms.cloud.microsoft/e/DSunC4sjH1?origin=lprLink",
      Link17: "https://forms.cloud.microsoft/e/2z9ZXLsnnf?origin=lprLink",
      Link18: "https://forms.cloud.microsoft/e/swjs4E3VNt?origin=lprLink",
      Link19: "https://forms.cloud.microsoft/e/5ckbiA8rDB?origin=lprLink",
      Link20: "https://forms.cloud.microsoft/e/Kp0zR7nN2e?origin=lprLink",
      Link21: "https://forms.cloud.microsoft/e/sx9LFXpb20?origin=lprLink",
      Link22: "https://forms.cloud.microsoft/e/XrGAzTCRU4?origin=lprLink",      
      PDF1: "",
      PDF1a: "",
      PDF2: "2_Entwicklungen_und_Modelle.pptx  -  Repariert.pdf",
      PDF2a: "",
      PDF3: "3_Grundbegriffe_der_Telematik.pdf",
      PDF3a: "",
      PDF4: "4_Hardware im lokalen Netz.pdf",
      PDF4a: "",
      PDF5: "5_Topologie und Verbindungsaufbau.pdf",
      PDF5a: "",
      PDF6: "6_IEEE-802.x-Standardfamilie Teil1.pdf",
      PDF6a: "6_IEEE-802.x-Standardfamilie Teil2.pdf",
      PDF7: "7_Netzwerk ohne Kabel_ Drahtlostechnologien.pdf",
      PDF7a: "",
      PDF8: "8_WAN-Datentechniken auf OSI-Layer 1 bis 3.pdf",
      PDF8a: "",
      PDF9: "9_ Mein Name ist IP.pdf",
      PDF9a: "",
      PDF10: "10_Weitere Protokolle im TCP-IP-Stack.pdf",
      PDF10a: "",
      PDF11: "11_Netzwerkdienste.pdf",
      PDF11a: "",
      PDF12: "12_ Netzwerke betreiben.pdf",
      PDF12a: "",
      PDF13: "13_ Sicherheitsverfahren im Netzwerkverkehr.pdf",
      PDF13a: "",
      PDF14: "14_ Verschiedene Angriffsformen im Netzwerk.pdf",
      PDF14a: "",
      PDF15: "15_ Die Verteidigung des Netzwerks.pdf",
      PDF15a: "",
      PDF16: "16_ Remote Access Networks.pdf",
      PDF16a: "",
      PDF17: "17_ Netzwerkmanagement.pdf",
      PDF17a: "",
      PDF18: "18_ Überwachung.pdf",
      PDF18a: "",
      PDF19: "19_ Fehlersuche im Netzwerk.pdf",
      PDF19a: "",
      PDF20: "20_ Praxis 1_ Sie richten ein Netzwerk ein.pdf",
      PDF20a: "",
      PDF21: "21_ Praxis 2_ Sie richten ein WLAN ein.pdf",
      PDF21a: "",
      PDF22: "22_ Praxis 3_ Steigern Sie die Netzeffizienz.pdf",
      PDF22a: "",


      PDF_sonstige1: "",
      PDF_sonstige2: "",
      PDF_sonstige3: "",
      PDF_sonstige4: "",
      PDF_sonstige5: "",
      PDF_sonstige6: "",
      PDF_sonstige7: "",
      PDF_sonstige8: "",
      PDF_sonstige9: "",
      PDF_sonstige10: "",
      PDF_sonstige11: "",
      PDF_sonstige12: "",
      PDF_sonstige13: "",
      PDF_sonstige14: "",
      PDF_sonstige15: "",
      PDF_sonstige16: "",
      PDF_sonstige17: "",
      PDF_sonstige18: "",
      PDF_sonstige19: "",
      PDF_sonstige20: "",
      quiz90_1: "",
      quiz90_2: "",
      quiz90_3: "",
      quiz90_4: "",
      quiz90_5: "",
      quiz90_6: "",
      quiz90_7: "",
      quiz90_8: "",
      quiz90_9: "",
      quiz90_10: "",
    };
  },
  components: {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
